// Firebase (Identity Platform) client for the oneselfpath-dev project — same shape as
// intellinurse/src/lib/firebase.ts. Patients live in their own Firebase project, not in
// the platform's (INT-38 spec §7.1).
import { getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { connectAuthEmulator, getAuth, type Auth } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const useEmulator = import.meta.env.VITE_FIREBASE_USE_EMULATOR === "true";

/** VITE_USE_MOCK_AUTH=true — a fake signed-in patient, no Firebase at all. */
export const IS_MOCK_AUTH = import.meta.env.VITE_USE_MOCK_AUTH === "true";

let app: FirebaseApp | undefined;
let authInstance: Auth | undefined;

export function getFirebaseApp(): FirebaseApp | undefined {
  if (typeof window === "undefined" || IS_MOCK_AUTH) return undefined;
  if (!app) app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  return app;
}

export function getFirebaseAuth(): Auth {
  if (IS_MOCK_AUTH) throw new Error("Firebase Auth is disabled in mock mode");
  const a = getFirebaseApp();
  if (!a) throw new Error("Firebase Auth is not available");
  if (!authInstance) {
    authInstance = getAuth(a);
    if (useEmulator) connectAuthEmulator(authInstance, "http://localhost:9099", { disableWarnings: true });
  }
  return authInstance;
}
